import { useTasks } from "../Tasks";

const Push = ({ id, complete, pushed }) => {
  const { todaysDate, pushToTomorrow } = useTasks();

  const done = () => {
    pushToTomorrow(id);
  };

  if (pushed <= todaysDate && complete === false) {
    return (
      <button className="btn down-btn" onClick={done}>
        Push
      </button>
    );
  } else {
    return null;
  }
};

export default Push;
